export const CALL_CONNECT_FILTER_STATE_VERSION = 3;
const CALL_CONNECT_FILTER_STATE_KEY = "sb_call_connect_filters";

export interface PersistedCallConnectFilterState {
  version: number;
  bucketOptionId: string;
  dateRange: (string | null)[] | null;
  selectedCompletionDispositions: (string | number)[];
  selectedActivatedDispositions: (string | number)[];
  timePeriod: string | null;
}

export interface SaveCallConnectFilterStateArgs {
  bucketOptionId?: string | null;
  dateRange?: (Date | string | null)[] | null;
  selectedCompletionDispositions?: (string | number)[] | null;
  selectedActivatedDispositions?: (string | number)[] | null;
  timePeriod?: string | null;
}

function serializeDate(value: Date | string | null | undefined): string | null {
  if (!value) return null;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed.toISOString();
}

export function saveCallConnectFilterState(state?: SaveCallConnectFilterStateArgs): void {
  if (typeof window === "undefined" || !state) return;

  const payload: PersistedCallConnectFilterState = {
    version: CALL_CONNECT_FILTER_STATE_VERSION,
    bucketOptionId: state.bucketOptionId ?? "all",
    dateRange: Array.isArray(state.dateRange)
      ? state.dateRange.map((date) => serializeDate(date))
      : null,
    selectedCompletionDispositions: Array.isArray(state.selectedCompletionDispositions)
      ? [...state.selectedCompletionDispositions]
      : [],
    selectedActivatedDispositions: Array.isArray(state.selectedActivatedDispositions)
      ? [...state.selectedActivatedDispositions]
      : [],
    timePeriod: state.timePeriod ?? null,
  };

  try {
    window.localStorage.setItem(CALL_CONNECT_FILTER_STATE_KEY, JSON.stringify(payload));
  } catch (error) {
    console.warn("Failed to persist call-connect filters:", error);
  }
}

export function loadCallConnectFilterState(): PersistedCallConnectFilterState | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(CALL_CONNECT_FILTER_STATE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PersistedCallConnectFilterState;
    if (parsed?.version !== CALL_CONNECT_FILTER_STATE_VERSION) {
      return null;
    }
    return parsed;
  } catch (error) {
    console.warn("Failed to read call-connect filters:", error);
    return null;
  }
}

export function clearCallConnectFilterState(): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(CALL_CONNECT_FILTER_STATE_KEY);
  } catch (error) {
    console.warn("Failed to clear call-connect filters:", error);
  }
}
